import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IStationCombination,
  IStationCombinationRow,
} from '../../../../view/settings/api-automation-settings/station-combinations/station-combinations.model';

@Injectable({
  providedIn: 'root',
})
export class StationCombinationService {
  private readonly STATION_COMBINATIONS_URL = `${this.baseUrl}/api-automation/station-combinations`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IStationCombination>> {
    return this.http.get<GetManyResponseInterface<IStationCombination>>(this.STATION_COMBINATIONS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IStationCombination>> {
    return this.http.get<BaseOneResponseInterface<IStationCombination>>(
      `${this.STATION_COMBINATIONS_URL}/${recordId}`,
      { params },
    );
  }

  public addOne(record: IStationCombinationRow): Observable<BaseOneResponseInterface<IStationCombination>> {
    return this.http.post<BaseOneResponseInterface<IStationCombination>>(this.STATION_COMBINATIONS_URL, record);
  }

  public editOne(
    recordId: number,
    record: IStationCombinationRow,
  ): Observable<BaseOneResponseInterface<IStationCombination>> {
    return this.http.patch<BaseOneResponseInterface<IStationCombination>>(
      `${this.STATION_COMBINATIONS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          stationCombinations: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.STATION_COMBINATIONS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.STATION_COMBINATIONS_URL}/${recordIds[0]}`);
  }
}
